module.exports = __webpack_public_path__ + "img/wc.fb16f0d1.png";